export const defaultCountryCode = 840;
export const defaultCountryName = 'United States of America';
